import { PrinterPosRefreshOutlineIcon } from './PrinterPosRefreshOutlineIcon';

/**
 * author: Colton Wiscombe
 * id D5843C28-5203-42D5-A874-8BE28012EFA8
 * name printer-pos-refresh-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-refresh-outline.svg
 * tags
 * - Printer 
 */
export const PrinterPointOfSaleRefreshOutlineIcon = PrinterPosRefreshOutlineIcon;
export default PrinterPointOfSaleRefreshOutlineIcon